<template>
  <span>
    <v-dialog max-width="500px" persistent v-model="dialog">
      <template #activator="{on}">
        <span v-on="on">
          <slot>
            <v-tooltip bottom>
              {{ $t("global.edit") }}
              <template #activator="{on}">
                <v-btn v-on="on" icon>
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </slot>
        </span>
      </template>

      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("settings.costCentre.form.title") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-text-field :label="$t('global.itemName')" :rules="[max25chars, required]" counter v-model="contextCostCentre.name"></v-text-field>

            <v-radio-group :mandatory="true" v-model="contextCostCentre.is_enabled">
              <v-radio :label="$t('settings.costCentre.form.disabled')" :value="0"></v-radio>
              <v-radio :label="$t('settings.costCentre.form.enabled')" :value="1"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialog = false" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click.native="save" color="blue darken-1" text>{{ $t("global.save") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  name: "CostCentreForm",
  props: {
    costCentre: {
      required: false,
      default: () => ({
        id: null,
        name: "",
        is_enabled: 1
      })
    }
  },
  data: () => {
    return {
      contextModel: {
        name: "",
        is_enabled: false
      },
      contextCostCentre: null,
      dialog: false,
      formValid: true
    };
  },
  created() {
    this.contextCostCentre = JSON.parse(JSON.stringify(this.costCentre));
  },
  methods: {
    max25chars(v) {
      return v == null || v.length <= 25 || this.$t("global.error.nameTooLong");
    },
    required(v) {
      return (v != null && v.length > 0) || this.$t("global.error.required");
    },
    save() {
      if (this.$refs.form.validate()) {
        this.axios
          .post("settings/cost-centre/save", this.contextCostCentre)
          .then(() => {
            if (this.costCentre.id == null) {
              this.contextCostCentre.name = "";
              this.contextCostCentre.is_enabled = false;
            }
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved")
            });
            this.$emit("saved");
            this.dialog = false;
          })
          .catch(resp => {
            console.log(resp.response);
          });
      }
    }
  }
};
</script>

<style scoped></style>
